export const RUNNING_SESSION_TYPES = [
    { value: "easy", label: "Rodagem leve" },
    { value: "recovery", label: "Regenerativo" },
    { value: "long_run", label: "Longão" },
    { value: "short_intervals", label: "Intervalado curto" },
    { value: "long_intervals", label: "Intervalado longo" },
    { value: "tempo", label: "Tempo run" },
    { value: "threshold", label: "Limiar" },
    { value: "fartlek", label: "Fartlek" },
    { value: "progressive", label: "Progressivo" },
    { value: "hill", label: "Subida" },
    { value: "drills", label: "Educativos" },
    { value: "test", label: "Teste de pace" },
    { value: "walk_run", label: "Caminhada/corrida" },
    { value: "return", label: "Retorno" },
];

export const RUNNING_BLOCK_TYPES = [
    { value: "warmup", label: "Aquecimento" },
    { value: "main", label: "Principal" },
    { value: "intervals", label: "Tiros" },
    { value: "technique", label: "Técnica" },
    { value: "cooldown", label: "Desaquecimento" },
    { value: "logistics", label: "Logística" },
];

export const RUNNING_SEGMENT_TYPES = [
    { value: "warmup", label: "Aquecimento" },
    { value: "run", label: "Corrida" },
    { value: "interval", label: "Tiro" },
    { value: "recovery", label: "Recuperação" },
    { value: "walk", label: "Caminhada" },
    { value: "rest", label: "Descanso" },
    { value: "drill", label: "Educativo" },
    { value: "stride", label: "Stride" },
    { value: "hill", label: "Subida" },
    { value: "cooldown", label: "Desaquecimento" },
    { value: "note", label: "Observação" },
];

export const RUNNING_DURATION_TYPES = [
    { value: "distance", label: "Distância" },
    { value: "time", label: "Tempo" },
    { value: "open", label: "Livre" },
    { value: "lap_button", label: "Botão volta" },
    { value: "heart_rate", label: "Até FC" },
    { value: "power", label: "Até potência" },
];

export const RUNNING_TARGET_TYPES = [
    { value: "none", label: "Sem alvo" },
    { value: "pace", label: "Pace" },
    { value: "heart_rate", label: "FC" },
    { value: "power", label: "Potência" },
    { value: "cadence", label: "Cadência" },
    { value: "effort", label: "Esforço" },
];

export const RUNNING_INTENSITY_ZONES = [
    { value: "z1", label: "Z1", desc: "Regenerativo", color: "#2f9e44" },
    { value: "z2", label: "Z2", desc: "Leve/base", color: "#1c7ed6" },
    { value: "z3", label: "Z3", desc: "Moderado", color: "#f59f00" },
    { value: "z4", label: "Z4", desc: "Forte/limiar", color: "#f76707" },
    { value: "z5", label: "Z5", desc: "Muito forte", color: "#e03131" },
];

export const RUNNING_LOCATION_TYPES = [
    { value: "street", label: "Rua" },
    { value: "track", label: "Pista" },
    { value: "park", label: "Parque" },
    { value: "trail", label: "Trail" },
    { value: "treadmill", label: "Esteira" },
    { value: "sand", label: "Areia" },
];

export const RUNNING_TERRAIN_TYPES = [
    { value: "flat", label: "Plano" },
    { value: "rolling", label: "Ondulado" },
    { value: "hill", label: "Subida" },
    { value: "mixed", label: "Misto" },
    { value: "technical", label: "Técnico" },
];

export const RUNNING_PACE_GROUPS = [
    { value: "g1", label: "G1", desc: "Avançado", easyPace: "5:00-5:40", thresholdPace: "4:20-4:45", intervalPace: "4:00-4:20", longRunPace: "5:20-6:00" },
    { value: "g2", label: "G2", desc: "Intermediário", easyPace: "5:50-6:30", thresholdPace: "5:05-5:30", intervalPace: "4:45-5:05", longRunPace: "6:10-6:50" },
    { value: "g3", label: "G3", desc: "Iniciante", easyPace: "6:40-7:30", thresholdPace: "5:50-6:20", intervalPace: "5:30-5:50", longRunPace: "7:00-8:00" },
    { value: "return", label: "Retorno", desc: "Controle de carga", easyPace: "Livre", thresholdPace: "", intervalPace: "", longRunPace: "Caminhada/trote" },
];

export const DEFAULT_RUNNING_CLUB_SESSION = {
    isClubSession: false,
    teamName: "",
    coachName: "",
    meetingPoint: "",
    startTime: "",
    routeName: "",
    safetyNotes: "",
    paceGroups: RUNNING_PACE_GROUPS.slice(0, 3).map(group => ({ ...group, id: group.value, enabled: true })),
};

export const RUNNING_CYCLE_PHASES = [
    { value: "base", label: "Base" },
    { value: "build", label: "Construção" },
    { value: "specific", label: "Específica" },
    { value: "peak", label: "Polimento" },
    { value: "race", label: "Prova" },
    { value: "recovery", label: "Recuperação" },
];

export const DEFAULT_RUNNING_CYCLE_PLAN = {
    enabled: false,
    raceName: "",
    raceDate: "",
    raceDistance: "",
    weekNumber: "",
    totalWeeks: "",
    phase: "base",
    plannedWeeklyKm: "",
    previousWeeklyKm: "",
    deloadWeek: false,
    intensityEasyPercent: 80,
    intensityModeratePercent: 10,
    intensityHardPercent: 10,
    notes: "",
};

export const DEFAULT_RUNNING_ATTENDANCE_PLAN = {
    enabled: false,
    expectedAthletes: "",
    confirmedAthletes: "",
    checkedInAthletes: "",
    absentAthletes: "",
    completionRate: "",
    averagePerceivedEffort: "",
    fatigueNotes: "",
    incidentNotes: "",
    coachFeedback: "",
};

export const DEFAULT_RUNNING_SEGMENT = {
    type: "running_segment",
    segmentType: "run",
    label: "",
    reps: 1,
    durationType: "distance",
    distance: 1,
    distanceUnit: "km",
    duration: "",
    targetType: "pace",
    targetPaceMin: "",
    targetPaceMax: "",
    heartRateZone: "",
    powerZone: "",
    effortZone: "z2",
    cadenceTarget: "",
    restAfter: "",
    terrain: "flat",
    notes: "",
    paceGroups: [],
    paceGroupTargets: [],
    paceGroupTargetsById: {},
};

export const getRunningLabel = (items, value) =>
    items.find(item => item.value === value)?.label || value || "-";
